import path from 'path-browserify';
import React, { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { BackLink, CreateButton, IconLink, Page } from '~/components';
import { useIntegrations, useWorkspace } from '~/contexts';
import { Tag, Tags } from '../components/HeaderStyledComponents';
import HubspotIndicator from '../components/HubspotIndicator';
import SalesforceIndicator from '../components/SalesforceIndicator';
import CompanyToClientForm from './CompanyToClientForm';

const resolveEditPath = (to, { pathname } = {}) =>
  pathname ? (pathname.endsWith(to) ? pathname : path.resolve(pathname, to)) : '';

function CompanyHeader({ company }) {
  const location = useLocation();
  const { workspace } = useWorkspace();
  const integrations = useIntegrations();
  const history = useHistory();
  const [companyToClient, setCompanyToClient] = useState(false);

  return (
    <>
      <Page.Header>
        <BackLink defaultPath={`/app/${workspace.key}/pipeline/companies`} />
        <Page.Info>
          <Page.Eyebrow>Company Dashboard</Page.Eyebrow>
          <Page.Title>{company.name}</Page.Title>

          {integrations.salesforce && company?.salesforceCompany?.salesforceId && (
            <Tags>
              <Tag>
                <SalesforceIndicator />
              </Tag>
            </Tags>
          )}
          {integrations.hubspot && company?.hubspotCompany?.hubspotId && (
            <Tags>
              <Tag>
                <HubspotIndicator />
              </Tag>
            </Tags>
          )}
        </Page.Info>

        <Page.Actions>
          {company.permissions.manage && !company.client && (
            <CreateButton tooltip="New Client" onClick={() => setCompanyToClient(true)} />
          )}
          {company.permissions.manage && (
            <IconLink
              tooltip="Edit Company"
              icon="pencil-alt"
              to={`${resolveEditPath('edit', location)}${location.search}`}
            />
          )}
        </Page.Actions>
      </Page.Header>
      {company.permissions.manage && companyToClient && (
        <CompanyToClientForm
          company={company}
          onClose={() => setCompanyToClient(false)}
          onSaved={(client) => history.push(`/app/${workspace.key}/clients/${client.key}/overview/edit`)}
        />
      )}
    </>
  );
}

export default CompanyHeader;
